(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/mybets/mybets.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/mybets/mybets.js');
'use strict';

const GameLauncherWrapper = svs.tickets.next.areas.play.containers.GameLauncherWrapper;
const NavigationBack = svs.tur.NavigationBack;
const _React = React,
  useEffect = _React.useEffect;
const hasWagerData = rawWagerId => {
  if (rawWagerId === 'pagaende') {
    var _svs$tickets$data$fet;
    return Boolean((_svs$tickets$data$fet = svs.tickets.data.fetchedGames) === null || _svs$tickets$data$fet === void 0 ? void 0 : _svs$tickets$data$fet.length);
  }
  return Boolean(svs.tickets.data.fetchedGame);
};
const MyBets = _ref => {
  var _match$params;
  let history = _ref.history,
    location = _ref.location,
    match = _ref.match;
  const rawWagerId = match === null || match === void 0 || (_match$params = match.params) === null || _match$params === void 0 ? void 0 : _match$params.wagerId;
  const wagerDataExists = hasWagerData(rawWagerId);
  useEffect(() => {
    if (!wagerDataExists) {
      history.push('/');
    }
  }, [history, wagerDataExists]);
  const _ref2 = wagerDataExists ? svs.tickets.next.utils.utils.getTicketTypeFromWager(rawWagerId) : {},
    ticketType = _ref2.ticketType,
    wagerId = _ref2.wagerId,
    gameIsCompleted = _ref2.gameIsCompleted;
  const wager = svs.tickets.data.fetchedGame;
  const ticketInfo = wagerDataExists ? svs.tickets.next.utils.utils.getTicketInfo(ticketType, svs.tickets.data.scratchTickets) : null;
  const handleBack = () => {
    svs.utils.url.navigate(svs.core.urlMapping.get('myBetsHome'));
  };
  const currentPath = (location === null || location === void 0 ? void 0 : location.pathname) || window.location.pathname;
  const routes = {
    [currentPath]: {
      text: 'Start / Mina spel ',
      navigate: handleBack
    }
  };
  if (!wagerDataExists) {
    return null;
  }
  if (!ticketInfo || ticketInfo.isNotConfigured) {
    return React.createElement("div", null, "Lotten kunde inte hittas");
  }
  return React.createElement("div", {
    className: "w100 h100"
  }, React.createElement(NavigationBack, {
    brand: "next-lobby",
    routes: routes
  }), React.createElement(GameLauncherWrapper, {
    demo: false,
    gameIsCompleted: gameIsCompleted,
    history: history,
    onClose: handleBack,
    ticketInfo: ticketInfo,
    topBarTrackingLocation: "mina-spel",
    wager: wager,
    wagerId: wagerId
  }));
};
setGlobal('svs.tickets.next.areas.mybets.MyBets', MyBets);

 })(window);